import React, { useEffect, useState } from "react";
import ColorWheel from "./ColorWheel";

const containerStyle = {
  position: "fixed",
  zIndex: 1000,
  background: "#222",
  border: "1px solid #444",
  borderRadius: 8,
  padding: 8,
  boxShadow: "0 6px 18px rgba(0,0,0,0.6)",
  color: "#fff",
  overflow: "auto",
  height: 200,
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(6, 48px)",
  gap: 8,
  maxWidth: 48 * 6 + 8 * 5,
};

const itemStyle = {
  width: 48,
  height: 48,
  borderRadius: 6,
  overflow: "visible",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  background: "#111",
  border: "1px solid transparent",
  position: "relative",
  transition: "all 0.2s ease",
};

const PopoutIconGrid = ({ visible, anchor = { x: 0, y: 0 }, playerId, onSelect, onClose, currentColor = '#ff0000', onColorChange }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Extract friendly name from file path
  const getIconName = (src) => {
    const filename = src.split("/").pop(); // get last part of path
    return filename.replace(/\.[^.]+$/, ""); // remove file extension
  };

  const attackerIcons = [ 
    "/icons/r6s/operators/attackers/Ace.png",
    "/icons/r6s/operators/attackers/Amaru.png",
    "/icons/r6s/operators/attackers/Ash.png",
    "/icons/r6s/operators/attackers/Blackbeard.png",
    "/icons/r6s/operators/attackers/Blitz.png",
    "/icons/r6s/operators/attackers/Brava.png",
    "/icons/r6s/operators/attackers/Buck.png",
    "/icons/r6s/operators/attackers/Capitao.png",
    "/icons/r6s/operators/attackers/Deimos.png",
    "/icons/r6s/operators/attackers/Dokkaebi.png",
    "/icons/r6s/operators/attackers/Finka.png",
    "/icons/r6s/operators/attackers/Flores.png",
    "/icons/r6s/operators/attackers/Fuze.png",
    "/icons/r6s/operators/attackers/Glaz.png",
    "/icons/r6s/operators/attackers/Gridlock.png",
    "/icons/r6s/operators/attackers/Grim.png",
    "/icons/r6s/operators/attackers/Hibana.png",
    "/icons/r6s/operators/attackers/Iana.png",
    "/icons/r6s/operators/attackers/Iq.png",
    "/icons/r6s/operators/attackers/Jackal.png",
    "/icons/r6s/operators/attackers/Kali.png",
    "/icons/r6s/operators/attackers/Lion.png",
    "/icons/r6s/operators/attackers/Maverick.png",
    "/icons/r6s/operators/attackers/Montagne.png",
    "/icons/r6s/operators/attackers/Nokk.png",
    "/icons/r6s/operators/attackers/Nomad.png",
    "/icons/r6s/operators/attackers/Osa.png",
    "/icons/r6s/operators/attackers/Ram.png",
    "/icons/r6s/operators/attackers/Rauora.png",
    "/icons/r6s/operators/attackers/Sens.png",
    "/icons/r6s/operators/attackers/Sledge.png",
    "/icons/r6s/operators/attackers/SolidSnake.png",
    "/icons/r6s/operators/attackers/Striker.png",
    "/icons/r6s/operators/attackers/Thatcher.png",
    "/icons/r6s/operators/attackers/Thermite.png",
    "/icons/r6s/operators/attackers/Twitch.png",
    "/icons/r6s/operators/attackers/Ying.png",
    "/icons/r6s/operators/attackers/Zero.png",
    "/icons/r6s/operators/attackers/Zofia.png"
  ];
  const defenderIcons = [
    "/icons/r6s/operators/defenders/Alibi.png",
    "/icons/r6s/operators/defenders/Aruni.png",
    "/icons/r6s/operators/defenders/Azami.png",
    "/icons/r6s/operators/defenders/Bandit.png",
    "/icons/r6s/operators/defenders/Castle.png",
    "/icons/r6s/operators/defenders/Caveira.png",
    "/icons/r6s/operators/defenders/Clash.png",
    "/icons/r6s/operators/defenders/Denari.png",
    "/icons/r6s/operators/defenders/Doc.png",
    "/icons/r6s/operators/defenders/Echo.png",
    "/icons/r6s/operators/defenders/Ela.png",
    "/icons/r6s/operators/defenders/Fenrir.png",
    "/icons/r6s/operators/defenders/Frost.png",
    "/icons/r6s/operators/defenders/Goyo.png",
    "/icons/r6s/operators/defenders/Jager.png",
    "/icons/r6s/operators/defenders/Kaid.png",
    "/icons/r6s/operators/defenders/Kapkan.png",
    "/icons/r6s/operators/defenders/Lesion.png",
    "/icons/r6s/operators/defenders/Maestro.png",
    "/icons/r6s/operators/defenders/Melusi.png",
    "/icons/r6s/operators/defenders/Mira.png",
    "/icons/r6s/operators/defenders/Mozzie.png",
    "/icons/r6s/operators/defenders/Mute.png",
    "/icons/r6s/operators/defenders/Noor.png",
    "/icons/r6s/operators/defenders/Oryx.png",
    "/icons/r6s/operators/defenders/Pulse.png",
    "/icons/r6s/operators/defenders/Rook.png",
    "/icons/r6s/operators/defenders/Sentry.png",
    "/icons/r6s/operators/defenders/Skopos.png",
    "/icons/r6s/operators/defenders/Smoke.png",
    "/icons/r6s/operators/defenders/Solis.png",
    "/icons/r6s/operators/defenders/Tachanka.png",
    "/icons/r6s/operators/defenders/Thorn.png",
    "/icons/r6s/operators/defenders/Thunderbird.png",
    "/icons/r6s/operators/defenders/Tubarao.png",
    "/icons/r6s/operators/defenders/Valkyrie.png",
    "/icons/r6s/operators/defenders/Vigil.png",
    "/icons/r6s/operators/defenders/Wamai.png",
    "/icons/r6s/operators/defenders/Warden.png"
  ];
  
  useEffect(() => {
    if (!visible) return;
    const handler = (e) => {
      // click outside should close
      if (!e.target.closest || !e.target.closest(".popout-icon-grid")) onClose && onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [visible, onClose]);

  if (!visible) return null;

  const style = {
    ...containerStyle,
    left: Math.min(window.innerWidth - 320, Math.max(8, anchor.x)),
    top: Math.min(window.innerHeight - 120, Math.max(8, anchor.y)),
    width: 320,
    height: "auto",
    maxHeight: 360,
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  return (
    <div className="popout-icon-grid" style={style} role="dialog" aria-hidden={!visible}>
      <div style={{ marginBottom: 6, fontSize: 12 }}>Choose Operator</div>
      <ColorWheel color={currentColor} onChange={onColorChange} />
      <div style={{ ...gridStyle, overflowY: "auto", maxHeight: 260 }}>
        {(playerId >= 1 && playerId <= 5 ? attackerIcons : defenderIcons).map((src, i) => (
          <div
            key={src + i}
            style={itemStyle}
            onClick={() => onSelect && onSelect(src)}
            onMouseEnter={() => {
              setHoveredIndex(i);
            }}
            onMouseLeave={() => {
              setHoveredIndex(null);
            }}
          >
            <img src={src} alt="icon" style={{ width: 50, height: 50, objectFit: "contain" }} loading="lazy" />
            {hoveredIndex === i && (
              <div
                style={{
                  position: "absolute",
                  bottom: "100%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  marginBottom: 6,
                  backgroundColor: "#000",
                  color: "#FFFFFF",
                  padding: "4px 8px",
                  borderRadius: 4,
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  pointerEvents: "none",
                  zIndex: 1001,
                }}
              >
                {getIconName(src)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopoutIconGrid;
